// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UkXz","newExpiryDate":"styles_newExpiryDate__3XBz4","footer":"styles_footer__3D1VX"};